import React, { useState } from 'react';
import apiBaseUrl from '../../utils/config';
import ImageService from '../images/imageService';
import './SearchBar.css'; // ✅ Plain CSS import



const SearchBar = ({ role }) => {
  const [query, setQuery] = useState('');
  const [popupData, setPopupData] = useState(null); // { type, data }

  const handleSearch = async (e) => {
    if (e.key !== 'Enter') return;

    try {
      if (role === 'PATIENT') {
        const [insuranceResult, doctorResult] = await Promise.all([
          fetch(`${apiBaseUrl}/insurance/search/all?query=${query}`).then(res => res.json()),
          fetch(`${apiBaseUrl}/doctor/search/all?query=${query}`).then(res => res.json())
        ]);

        if (insuranceResult.length) {
          setPopupData({ type: 'insurance', data: insuranceResult[0] });
        } else if (doctorResult.length) {
          const doctor = doctorResult.find(doc => doc.specialty !== 'ADMIN' && doc.specialty !== 'FRONT_DESK');
          if (doctor) setPopupData({ type: 'doctor', data: doctor });
          else alert('Only doctors are viewable.');
        } else {
          alert('No results found.');
        }

      } else {
        const patientResult = await fetch(`${apiBaseUrl}/patient/search/all?query=${query}`).then(res => res.json());
        if (patientResult.length) setPopupData({ type: 'patient', data: patientResult[0] });
        else alert('No patients found.');
      }
    } catch (err) {
      console.error('Search failed', err);
    }
  };

  const closeModal = () => {
    setPopupData(null);
  };

  const renderPopupContent = () => {
    const { type, data } = popupData;

    if (type === 'insurance') {
      return (
        <>
          <h3>{data.insName}</h3>
          <p>Authorization: {data.authorization}</p>
          <p>Code: {data.insCode}</p>
          <p>Address: {data.address}</p>
          <p>Acceptance: {data.acceptance}</p>
          <p>Coverage: {data.coverageName}</p>
          <p>Days: {data.days}</p>
        </>
      );
    }

    if (type === 'doctor') {
      return (
        <>
          <h3>Dr. {data.firstName} {data.lastName}</h3>
          <p>Username: {data.username}</p>
          <p>Bio: {data.bio}</p>
          <img src={ImageService.getImageUrl('doctors', data.doctorPicture)} alt="Doctor" style={{ width: '100px' }} />
        </>
      );
    }

    if (type === 'patient') {
      return (
        <>
          <h3>{data.firstName} {data.lastName}</h3>
          <p>Username: {data.username}</p>
          <p>DOB: {data.dateOfBirth}</p>
          <p>Age: {data.age}</p>
          <p>Sex: {data.sex}</p>
          <p>Phone: {data.phoneNumber}</p>
          <p>Email: {data.email}</p>
          <p>Notes: {data.notes}</p>
        </>
      );
    }

    return null;
  };

  return (
    <div className="search-container">
      <input
        type="text"
        placeholder="Search..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onKeyDown={handleSearch}
        className="search-bar"
      />

      {/* Modal Popup */}
      {popupData && (
        <div className="modal">
          <div className="modal-content">
            <span className="close" onClick={closeModal}>&times;</span>
            <div className="popup-body">
              {renderPopupContent()}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchBar;
